export default __webpack_public_path__ + "static/media/CanyonOutpostMap.dadfcb92.jpg";